import React, { useState } from 'react'
import { Field } from 'redux-form/immutable'
import cn from 'classnames'

import EditIcon from 'app/components/SVGS/Edit'
import TextAreaWithConfirmAndCancel from 'app/components/TextArea/TextAreWithConfirmAndCancel'
import { ITextFieldEditorProps } from './interface'

import './styles.scss'

const bc = 'text-field-editor'

export const TextFieldEditor: React.FC<ITextFieldEditorProps> = ({
  className = '',
  editorClassName = '',
  name,
  onCancel,
  onConfirm,
  hideElement,
  isPageEdit = false,
  maxCharacters = 255,
}) => {
  const [showEditor, setShowEditor] = useState(false)
  if (!isPageEdit) {
    return null
  }
  return (
    <div className={bc}>
      <div
        className={cn(`${bc}__edit-icon`, className)}
        onClick={() => {
          setShowEditor(true)
          hideElement(true)
        }}
      >
        <EditIcon
          svgProps={{
            width: 18,
            height: 18,
          }}
          pathProps={{
            fill: '#087acb',
          }}
        />
      </div>
      {showEditor && (
        <div className={cn(`${bc}__editor-default`, { [editorClassName]: editorClassName })}>
          <Field
            component={TextAreaWithConfirmAndCancel}
            maxCharacters={maxCharacters}
            name={name}
            onCancel={() => {
              setShowEditor(false)
              onCancel()
              hideElement(false)
            }}
            onConfirm={() => {
              setShowEditor(false)
              onConfirm()
              hideElement(false)
            }}
          />
        </div>
      )}
    </div>
  )
}
